import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(null);
  const userId = ref<string | null>(null);
  const isAuthenticated = ref(false);

  function setToken(newToken: string | null) {
    token.value = newToken;
    isAuthenticated.value = !!newToken;
  }

  function setUserId(newUserId: string | null) {
    userId.value = newUserId;
  }

  function logout() {
    token.value = null;
    userId.value = null;
    isAuthenticated.value = false;
  }

  return {
    token,
    userId,
    isAuthenticated,
    setToken,
    setUserId,
    logout,
  };
});

export type AuthStore = ReturnType<typeof useAuthStore>; 